import React from 'react'

function Loader() {
  return (
    <div class="loader-bg">
    <div class="loader-track">
        <div class="loader-fill"></div>
    </div>
</div>
  )
}

export default Loader